import { routes as estudantes } from './estudantes'
import { routes as portais } from './portais'
import { routes as global } from './global'
export default [
  {
    path: '/publicas',
    name: 'Publicas',
    description: 'Módulo Público',
    children: [
      ...estudantes,
      ...portais,
      ...global
    ],
    goesToMenu: true
  }
]
